import React from "react";

import Education from "./resume/Education";
import Work from "./resume/Work";
import Awards from './resume/Awards';
import Publications from './resume/Publications';
import Volunteer from './resume/Volunteer';
import Speaker from './resume/Speaker';
import Skills from "./resume/Skills";

const Resume = () => (
  <section id="resume">
    <Education />
    <Work />
    <Volunteer />
    <Awards />
    <Publications />
    <Speaker />
    <Skills />
  </section>
);

export default Resume;



// WEBPACK FOOTER //
// ./src/components/Resume.js